export const WHITE = "#FFFFFF";
export const QUICK_SILVER_05 = "rgba(160, 159, 167, 0.5)";
export const GAINSBORO = "#dddfe1";
export const APPLE = "#83B643";
export const CADMIUM_ORANGE = "#EB8D35";
export const COLADON_BLUE = "#0178AE";
export const DR_WHITE = "#F9FAFB";
export const MELANCHOLIC_SEA = "#54778e";
export const BLUE_METAL = "#5b646f";
export const QUICK_SILVER = "#A09FA7";
export const ATTENTION_RED = "#FF2D39";
export const ATTENTION_RED_LINE = "#B93400";
export const STAGE_YELLOW = "#FFD700";
export const STAGE_YELLOW_LINE = "#F8A905";
